// Lightweight UI strings translator. The user can switch source language;
// these strings keep the chrome consistent in their chosen language.

const dict = {
  appName: { sv: 'Ballingo', en: 'Ballingo' },
  tagline: {
    sv: 'Lär dig kroatiska — en bit i taget.',
    en: 'Learn Croatian — one bite at a time.',
  },
  start: { sv: 'Starta', en: 'Start' },
  continue: { sv: 'Fortsätt', en: 'Continue' },
  practice: { sv: 'Repetera', en: 'Practice' },
  practiceCta: { sv: 'Snabbrepetition', en: 'Quick practice' },
  check: { sv: 'Kontrollera', en: 'Check' },
  continueBtn: { sv: 'Fortsätt', en: 'Continue' },
  skip: { sv: 'Hoppa över', en: 'Skip' },
  correct: { sv: 'Rätt!', en: 'Correct!' },
  wrong: { sv: 'Fel', en: 'Incorrect' },
  answer: { sv: 'Rätt svar', en: 'Correct answer' },
  yourAnswer: { sv: 'Ditt svar', en: 'Your answer' },
  typeAnswer: { sv: 'Skriv översättningen…', en: 'Type the translation…' },
  typeInHR: { sv: 'Skriv på kroatiska…', en: 'Type in Croatian…' },
  typeWhatYouHear: { sv: 'Skriv det du hör…', en: 'Type what you hear…' },
  promptHR: { sv: 'Översätt till kroatiska', en: 'Translate to Croatian' },
  promptFromHR: { sv: 'Översätt från kroatiska', en: 'Translate from Croatian' },
  promptListen: { sv: 'Lyssna och skriv på kroatiska', en: 'Listen and type in Croatian' },
  promptMC_toHR: { sv: 'Vad heter detta på kroatiska?', en: 'How do you say this in Croatian?' },
  promptMC_fromHR: { sv: 'Vad betyder detta?', en: 'What does this mean?' },
  promptWordBank: { sv: 'Bygg meningen', en: 'Build the sentence' },
  promptMatch: { sv: 'Para ihop paren', en: 'Match the pairs' },
  lessonComplete: { sv: 'Lektion klar!', en: 'Lesson complete!' },
  outOfHearts: { sv: 'Inga liv kvar', en: 'No hearts left' },
  outOfHeartsDetail: {
    sv: 'Liven återkommer av sig själva — eller fyll på direkt.',
    en: 'Hearts regenerate over time — or refill instantly.',
  },
  refillHearts: { sv: 'Fyll på liv', en: 'Refill hearts' },
  exit: { sv: 'Avsluta', en: 'Exit' },
  exitConfirm: {
    sv: 'Vill du verkligen avsluta lektionen? Du tappar framstegen.',
    en: 'Are you sure you want to quit? You’ll lose lesson progress.',
  },
  xpEarned: { sv: 'XP intjänad', en: 'XP earned' },
  streak: { sv: 'Streak', en: 'Streak' },
  dailyGoal: { sv: 'Dagligt mål', en: 'Daily goal' },
  hearts: { sv: 'Liv', en: 'Hearts' },
  level: { sv: 'Nivå', en: 'Level' },
  settings: { sv: 'Inställningar', en: 'Settings' },
  sourceLang: { sv: 'Visa instruktioner på', en: 'Show instructions in' },
  reset: { sv: 'Återställ all framgång', en: 'Reset all progress' },
  resetConfirm: {
    sv: 'Är du säker? Detta nollställer XP, streak och alla lektioner.',
    en: 'Are you sure? This wipes XP, streak and all lessons.',
  },
  swedish: { sv: 'Svenska', en: 'Swedish' },
  english: { sv: 'Engelska', en: 'English' },
  done: { sv: 'Klar', en: 'Done' },
  back: { sv: 'Tillbaka', en: 'Back' },
  locked: { sv: 'Låst', en: 'Locked' },
  finishPrev: { sv: 'Klara lektionen ovan först', en: 'Finish the lesson above first' },
  lesson: { sv: 'Lektion', en: 'Lesson' },
  reviewLesson: { sv: 'Repetition', en: 'Review' },
  mastered: { sv: 'Bemästrad!', en: 'Mastered!' },
  noVoice: {
    sv: 'Ingen kroatisk röst hittades i webbläsaren. Texten visas istället.',
    en: 'No Croatian voice found in this browser. Text shown instead.',
  },
  todayProgress: { sv: 'Idag', en: 'Today' },
  best: { sv: 'Bästa', en: 'Best' },
  lessons: { sv: 'lektioner', en: 'lessons' },
  totalXP: { sv: 'Total XP', en: 'Total XP' },
  startLesson: { sv: 'Starta lektion', en: 'Start lesson' },
  retryLesson: { sv: 'Försök igen', en: 'Try again' },
  reviewSkill: { sv: 'Repetera kompetens', en: 'Review skill' },
  reviewAll: { sv: 'Blandad repetition', en: 'Mixed practice' },
  tapToHear: { sv: 'Tryck för att höra', en: 'Tap to hear' },

  // Sprint 1 — new exercise types
  clozeHeader:     { sv: 'FYLL I LUCKAN',         en: 'FILL THE BLANK' },
  clozeTitle:      { sv: 'Välj rätt ord',         en: 'Pick the right word' },
  listenSlow:      { sv: 'Långsamt',              en: 'Slow' },
  pairsHeader:     { sv: 'PARA IHOP',             en: 'MATCH THE PAIRS' },

  // Sprint 2 — image choice, speed round, speaking toggle
  imageHeader:     { sv: 'VÄLJ RÄTT BILD',        en: 'PICK THE RIGHT IMAGE' },
  speedRoundTitle: { sv: 'Snabbrunda',            en: 'Speed round' },
  speedRoundCta:   { sv: 'Starta snabbrunda',     en: 'Start speed round' },
  speedRoundTimeUp:{ sv: 'Tiden är ute!',         en: "Time's up!" },
  speedRoundBest:  { sv: 'Bästa resultat',        en: 'Best score' },
  speedRoundLocked:{ sv: 'Klara 3 lektioner först', en: 'Finish 3 lessons first' },
  again:           { sv: 'Igen',                  en: 'Again' },
  score:           { sv: 'Poäng',                 en: 'Score' },
  settingsSpeaking:{ sv: 'Inkludera tal-övningar', en: 'Include speaking exercises' },

  // Sprint 3 — speak / stories
  speakHeader:     { sv: 'SÄG DET HÖGT',          en: 'SAY IT OUT LOUD' },
  speakTap:        { sv: 'Tryck för att tala',    en: 'Tap to speak' },
  speakListening:  { sv: 'Lyssnar…',              en: 'Listening…' },
  speakSkip:       { sv: 'Hoppa över',            en: 'Skip' },
  speakNoMic:      {
    sv: 'Mikrofonen är avstängd. Hoppa över eller aktivera tal-övningar i Inställningar.',
    en: 'Microphone is off. Skip, or enable speaking exercises in Settings.',
  },
  speakDenied:     {
    sv: 'Inget problem — vi hoppar tal-övningar idag.',
    en: "No worries — we'll skip speaking today.",
  },
  storiesRail:     { sv: 'Berättelser',           en: 'Stories' },
  storyComplete:   { sv: 'Berättelse klar!',      en: 'Story complete!' },
};

export function t(key, lang = 'sv') {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] || entry.en || entry.sv || key;
}
